<div class="row g-1 flex-fill">
  <div class="col-auto flex-fill d-flex">
    <app-simple-grid
      [listOperator]="listRentalAgreementDocumentsOperator"
      [columnDefs]="columnDefs"
      class="flex-fill"
      style="min-height: 300px" />
  </div>
  <!-- <div class="col-12 p-1">
    <div class="small fw-semibold m-0">
      <span>Balance</span>
    </div>
    <div class="row g-1 mx-0">
      <div class="col-12 col-sm-6 col-lg-3 col-xxl-2">
        <div class="form-floating">
          <input
            type="number"
            class="form-control validated fw-bolder text-success"
            [value]="rentalAgreement()?.totalValueWithTax | number: '1.2-2'"
            disabled
            id="debits"
            formControlName="debits" />
          <label for="debits">Debits</label>
        </div>
      </div>
      <div class="col-12 col-sm-6 col-lg-3 col-xxl-2">
        <div class="form-floating">
          <input
            type="number"
            class="form-control validated fw-bolder text-danger"
            [value]="rentalAgreement()?.totalValueWithTax | number: '1.2-2'"
            disabled
            id="credits"
            formControlName="credits" />
          <label for="credits">Credits</label>
        </div>
      </div>
      <div class="col-12 col-sm-6 col-lg-3 col-xxl-2">
        <div class="form-floating">
          <input
            type="number"
            class="form-control validated fw-bolder"
            value="0"
            id="balance"
            disabled
            formControlName="balance" />
          <label for="balance">Balance</label>
        </div>
      </div>
    </div>
  </div> -->
</div>
